import { Drawer, DrawerBody, DrawerHeader, DrawerOverlay, DrawerContent, useDisclosure, Flex, Icon, useToast, Box } from '@chakra-ui/react'
import React, { useEffect } from 'react'
import { Button } from '../../../../../../components/Button'
import { AiFillPlusCircle, AiOutlineArrowLeft } from 'react-icons/ai'
import { Input } from '../../../../../../components/Form'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { api } from '../../../../../../services/api'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { ListContato } from './ListContato'
import { motion } from 'framer-motion'
import { InputMaskForm } from '../../../../../../components/Form/InputMaskForm'
import { useParams } from 'react-router-dom'
import { format } from 'date-fns'
import { formatPrice } from '../../../../../../utils/formatPrice'
import { schema } from './@schemas'

async function searchCep(cep) {
  const response = await api.get(`/site/v2/pedido/busca-endereco-cliente/${cep}`)

  return response.data[0]
}

async function onDeleteEndereco({ numero_nota, codigo_parceiro }) {
  const response = await api.put('/site/v2/orcamento-crm/remover-cliente-entrega-crm', {
    numero_nota,
    codigo_parceiro,
  })

  return response.data
}

async function updateEntrega({
  codigo_parceiro,
  cep,
  cnpj,
  complemento,
  nome_parceiro,
  numero_nota,
  email_parceiro,
  telefone,
  celular,
  ramal,
  codigo_contato,
  razao_social,
  numero,
  entrega,
}) {
  const response = await api.put('site/v2/orcamento-crm/atualiza-endereco-faturamento', {
    codigo_parceiro,
    cep,
    cnpj,
    complemento,
    nome_parceiro,
    numero_nota,
    email_parceiro,
    telefone,
    celular,
    ramal,
    codigo_contato,
    razao_social,
    numero,
    entrega,
  })

  return response.data
}

export function DadosEntrega({ infoProposta }) {

  console.log('infoProposta', infoProposta)

  const { isOpen, onOpen, onClose } = useDisclosure()
  const [searchParceiro, setSearchParceiro] = React.useState(false)
  const [parceiroSelecionado, setParceiroSelecionado] = React.useState(null)
  const btnRef = React.useRef()
  const { numeroProposta: numProposta } = useParams()
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    watch,
    control,
  } = useForm({
    resolver: zodResolver(schema),
  })

  const cep = watch('cep')

  const queryClient = useQueryClient()

  const toast = useToast({
    position: 'top-right',
    isClosable: true,
  })

  const { mutateAsync: deletarEndereco, isLoading: loadingDeletarEndereco } = useMutation({
    mutationFn: onDeleteEndereco,
    onSuccess: () => {
      setValue('cep', '')
      queryClient.setQueryData(['items', numProposta], (oldData) => {
        return {
          ...oldData,
          informacao_da_proposta: {
            ...oldData.informacao_da_proposta,
            dados_entrega: {
              ...oldData.informacao_da_proposta.dados_entrega,
              endereco: null,
              numero: null,
              complemento: null,
              bairro: null,
              cidade: null,
              uf: null,
              cep: null,
              telefone: null,
              ramal: null,
            },
          },
        }
      })

      toast({
        title: 'Endereço de entrega removido com sucesso',
        status: 'success',
      })
    },
    onError: () => {
      toast({
        title: 'Erro ao remover endereço de entrega',
        status: 'error',
      })
    },
  })

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: updateEntrega,
    onSuccess: (data) => {
      queryClient.setQueryData(['items', numProposta], (oldData) => {
        return {
          ...oldData,
          informacao_da_proposta: {
            ...oldData.informacao_da_proposta,
            total_valor_pedidos: formatPrice(data.total_valor_pedidos),
            cliente: {
              ...data.cliente,
              data_retorno: data.cliente.data_retorno ? format(new Date(data.cliente.data_retorno), 'dd/MM/yyyy') : null,
            },
            dados_entrega: {
              ...data.dados_entrega,
            },
          },
        }
      })

      toast({
        title: 'Dados de entrega atualizados com sucesso',
        status: 'success',
      })

      onClose()
    },

    onError: () => {
      toast({
        title: 'Erro ao atualizar os dados de entrega',
        status: 'error',
      })
    },
  })

  async function handleDeleteEndereco() {
    await deletarEndereco({ numero_nota: infoProposta.num_proposta, codigo_parceiro: infoProposta.dados_entrega.codigo_parceiro })
  }

  async function handleUpdateEntrega(data) {
    const params = {
      codigo_parceiro: data.codParc ? data.codParc : infoProposta.dados_entrega.codigo_parceiro,
      cep: data.cep,
      razao_social: data.razaoSocial,
      cnpj: data.cpfCnpj ? data.cpfCnpj.replace(/[^0-9]/g, '') : infoProposta.dados_entrega.cnpj,
      inscricao_estadual: data.inscricaoEstadual,
      complemento: data.complemento,
      nome_parceiro: data.razaoSocial ? data.razaoSocial : infoProposta.dados_entrega.razao_social,
      numero_nota: infoProposta.num_proposta,
      telefone: data.telefone,
      ramal: data.ramal,
      // codigo_contato: infoProposta.dados_entrega.codigo_contato,
      numero: data.numero,
      entrega: true,
    }

    await mutateAsync(params)
  }

  const {
    data: endereco,
    isLoading: loadingEndereco,
    refetch,
  } = useQuery({
    queryKey: 'endereco',
    queryFn: () => searchCep(cep),
    refetchOnWindowFocus: false,
    enabled: false,
    staleTime: 1000 * 60 * 10,
    onSuccess: (data) => {
      setValue('endereco', data.rua)
      setValue('bairro', data.bairro)
      setValue('cidade', data.estado)
      setValue('uf', data.uf)
    },
    onError: () => {
      toast({
        title: 'CEP não encontrado',
        status: 'error',
      })
    },
  })

  async function handleSearchCep(data) {
    await refetch()
  }

  useEffect(() => {
    setValue('razaoSocial', infoProposta?.dados_entrega?.razao_social)
    setValue('cpfCnpj', infoProposta?.dados_entrega?.cnpj)
    setValue('inscricaoEstadual', infoProposta?.dados_entrega?.inscricao_estadual)
    setValue('codParc', infoProposta?.dados_entrega?.codigo_parceiro)
    setValue('endereco', infoProposta?.dados_entrega?.endereco)
    setValue('numero', infoProposta?.dados_entrega?.numero)
    setValue('complemento', infoProposta?.dados_entrega?.complemento)
    setValue('bairro', infoProposta?.dados_entrega?.bairro)
    setValue('cidade', infoProposta?.dados_entrega?.cidade)
    setValue('uf', infoProposta?.dados_entrega?.sigla)
    setValue('cep', infoProposta?.dados_entrega?.cep)
    setValue('telefone', infoProposta?.dados_entrega?.telefone)
    setValue('ramal', infoProposta?.dados_entrega?.ramal)
  }, [infoProposta, setValue, onOpen])




  return (
    <>
      <Icon pointerEvents={'auto'} as={AiFillPlusCircle} color="#378BBF" fontSize="20px" onClick={onOpen} ref={btnRef} cursor="pointer" />
      <Drawer isOpen={isOpen} onClose={onClose} finalFocusRef={btnRef} placement="bottom">
        <DrawerOverlay />
        <DrawerContent minH="100vh">
          <DrawerHeader bgColor="#378BBF" textAlign="center" color="#F5F5F5" textTransform="uppercase">
            Dados de Entrega
          </DrawerHeader>
          {!searchParceiro && (
            <>
              <DrawerBody
                maxW="500px"
                w="100%"
                mx="auto"
                display="flex"
                flexDir="column"
                alignItems="center"
                justifyContent="center"
                gap={10}
                as="form"
                onSubmit={handleSubmit(handleUpdateEntrega)}
              >
                <Flex w="100%" flexDir="column" gap={2}>
                  <Flex alignItems="end" gap={2} justifyContent="space-between">
                    <Input label="Cod Parc" width="53px" id="codParc" {...register('codParc')} name="codParc" error={errors.codParc} disabled />

                    {
                      !infoProposta.valida_bloqueio && (
                        <>
                          <Button maxW="181px" w="100%" fontSize="13px" fontWeight="semibold" size="sm" onClick={() => setSearchParceiro(true)}>
                            Pesquisar parceiro
                          </Button>

                          <Button
                            bgColor="red.500"
                            maxW="181px"
                            w="100%"
                            fontSize="13px"
                            fontWeight="semibold"
                            size="sm"
                            onClick={handleDeleteEndereco}
                            isLoading={loadingDeletarEndereco}
                          >
                            Remover endereço
                          </Button>
                        </>
                      )
                    }

                  </Flex>

                  <Flex alignItems="center" gap={2}>
                    <InputMaskForm
                      label="CPF/Cnpj"
                      width="142px"
                      control={control}
                      id="cpfCnpj"
                      name="cpfCnpj"
                      error={errors.cpfCnpj}
                      mask={infoProposta.info_faturamento?.cnpj.length === 14 ? '99.999.999/9999-99' : '999.999.999-99'}
                      disabled={infoProposta.valida_bloqueio}
                    />
                    <Input label="Razão Social" id="razaoSocial" {...register('razaoSocial')} name="razaoSocial" error={errors.razaoSocial} disabled={infoProposta.valida_bloqueio} />
                    <Input label="Inscrição Estadual" id="inscricaoEstadual" {...register('inscricaoEstadual')} name="inscricaoEstadual" error={errors.razaoSocial} disabled={true} />
                  </Flex>
                  <Flex alignItems="center" gap={2}>
                    <InputMaskForm label="Telefone" control={control} id="telefone" name="telefone" error={errors.telefone} mask="(99) 9999-9999" disabled={infoProposta.valida_bloqueio} />
                    <Input label="Ramal" id="ramal" {...register('ramal')} name="ramal" error={errors.ramal} disabled={infoProposta.valida_bloqueio} />
                  </Flex>
                  <Flex alignItems="end" gap={2}>
                    <InputMaskForm label="CEP" control={control} id="cep" name="cep" error={errors.cep} mask="99999-999" disabled={infoProposta.valida_bloqueio} />

                    <Button
                      maxW="142px"
                      w="100%"
                      fontSize="13px"
                      fontWeight="semibold"
                      size="sm"
                      isLoading={loadingEndereco}
                      onClick={handleSearchCep}
                      disabled={infoProposta.valida_bloqueio}
                    >
                      Pesquisar CEP
                    </Button>
                  </Flex>
                  <Flex alignItems="center" gap={2}>
                    <Input label="Endereço" id="endereco" {...register('endereco')} name="endereco" error={errors.endereco} disabled />
                    <Input label="Número" id="numero" width="142px" {...register('numero')} name="numero" error={errors.numero} disabled={infoProposta.valida_bloqueio} />
                  </Flex>
                  <Flex alignItems="center" gap={2}>
                    <Input label="Bairro" id="bairro" {...register('bairro')} name="bairro" error={errors.bairro} disabled />
                    <Input
                      label="Complemento"
                      id="complemento"
                      width="142px"
                      {...register('complemento')}
                      name="complemento"
                      error={errors.complemento}
                      disabled={infoProposta.valida_bloqueio}
                    />
                  </Flex>
                  <Flex alignItems="center" gap={2}>
                    <Input label="Cidade" id="cidade" {...register('cidade')} name="cidade" error={errors.cidade} disabled />
                    <Input label="UF" id="estado" width="142px" {...register('uf')} name="uf" error={errors.uf} disabled />
                  </Flex>
                </Flex>

                <Flex alignItems="center" justifyContent="space-between" w="100%">
                  <Button
                    maxW="181px"
                    w="100%"
                    fontSize="15px"
                    fontWeight="semibold"
                    bgColor="transparent"
                    color="#FFA200"
                    border="1px solid #FFA200"
                    //fecha modal
                    onClick={onClose}
                  >
                    <AiOutlineArrowLeft style={{ marginRight: '5px' }} />
                    Voltar
                  </Button>

                  {
                    !infoProposta.valida_bloqueio && (
                      <Button maxW="181px" w="100%" fontSize="15px" fontWeight="semibold" type="submit" isLoading={isLoading}>
                        salvar alteração
                      </Button>
                    )
                  }

                </Flex>
              </DrawerBody>
            </>
          )}

          {searchParceiro && (
            <DrawerBody maxW="800px" w="100%" mx="auto" display="flex" flexDir="column" alignItems="center" justifyContent="center" gap={10}>
              <Box
                as={motion.div}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                w="100%"
                display="flex"
                flexDir="column"
                alignItems="center"
                justifyContent="center"
                gap={10}
              >
                <ListContato setParceiroSelecionado={setParceiroSelecionado} parceiroSelecionado={parceiroSelecionado} />

                <Flex alignItems="center" justifyContent="space-between" w="100%">
                  <Button
                    maxW="181px"
                    w="100%"
                    fontSize="15px"
                    fontWeight="semibold"
                    bgColor="transparent"
                    color="#FFA200"
                    border="1px solid #FFA200"
                    //fecha modal
                    onClick={() => setSearchParceiro(false)}
                  >
                    <AiOutlineArrowLeft style={{ marginRight: '5px' }} />
                    Voltar
                  </Button>
                  <Button
                    maxW="181px"
                    w="100%"
                    fontSize="15px"
                    fontWeight="semibold"
                    isLoading={isLoading}
                    isDisabled={!parceiroSelecionado}
                    //volta para a tela de cadastro
                    onClick={() => {
                      setValue('codParc', parceiroSelecionado?.codigo_parceiro)
                      setValue('cpfCnpj', parceiroSelecionado?.cnpj)
                      setValue('razaoSocial', parceiroSelecionado?.razao_social)
                      setValue('endereco', parceiroSelecionado?.endereco)
                      setValue('numero', parceiroSelecionado?.numero)
                      setValue('complemento', parceiroSelecionado?.complemento)
                      setValue('bairro', parceiroSelecionado?.bairro)
                      setValue('cidade', parceiroSelecionado?.cidade)
                      setValue('uf', parceiroSelecionado?.sigla)
                      setValue('email', parceiroSelecionado?.email)
                      setValue('cep', parceiroSelecionado?.cep)
                      setValue('telefone', parceiroSelecionado?.telefone)
                      setValue('ramal', parceiroSelecionado?.ramal)
                      setSearchParceiro(false)
                    }}
                  >
                    Confirmar
                  </Button>
                </Flex>
              </Box>
            </DrawerBody>
          )}
        </DrawerContent>
      </Drawer>
    </>
  )
}
